module.exports = __webpack_public_path__ + "img/cg_icon.2d96dc5.png";